import appScreenSelectors from '@/screens/apps/redux/selectors/appScreenSelectors';
import credentialScreenSelectors from '@/screens/apps/redux/selectors/credentialScreenSelectors';
import workflowScreenSelectors from '@/screens/workflows/redux/selectors/workflowScreenSelectors';
import { createSelector } from 'reselect';
import { jobById } from './jobsSelectors';
import formatTitle from './lib/formatTitle.js';
import selectors from './selectors';
import { query } from './querySelectors.js';

export const routeGroupTitles = createSelector(
  [
    workflowScreenSelectors.activeWorkflow, //
    credentialScreenSelectors.activeCredential,
    appScreenSelectors.activeApp,
    (state) => jobById(state, selectors.param(state, 'jobId')),
    (state) => null, // Replace with actual selector when available
    (state) => query(state, 'tab'),
    (state) => selectors.param(state, 'category'),
    (state) => selectors.param(state, 'section')
  ],
  (workflow, credential, app, job, embedded, monitoringTab, adminSettingsCategory, userSettingsCategory) => ({
    home: 'Home',
    recipes: 'Recipes',
    workflows: workflow?.name ? `${workflow.name} - Workflows` : 'Workflows',
    credentials: credential?.meta?.label ? `${credential.meta.label} - Connections` : 'Connections',
    apps: app?.name ? `${app.name} - Apps` : 'Apps',
    embedded: embedded?.name ? `${embedded.name} - Integrations` : 'Integrations',
    jobs: job?.name ? `${job.name} - Jobs` : 'Jobs',
    monitoring: `${monitoringTab ? formatTitle(monitoringTab) : 'Workflows'} - Monitoring`,
    adminSettings: adminSettingsCategory ? `${formatTitle(adminSettingsCategory)} - Admin Settings` : 'Admin Settings',
    userSettings: userSettingsCategory ? `${formatTitle(userSettingsCategory)} - Settings` : 'Settings',
    signup: 'Sign Up',
    privateBetaSignUp: 'Sign Up',
    login: 'Sign In',
    design: 'Design'
  })
);

// Selector to get the active title based on route group name
export const getActiveTitle = createSelector(
  routeGroupTitles,
  (_, name) => name,
  (groupTitles, name) => {
    const groupTitle = groupTitles[name];
    return groupTitle ? `${groupTitle} - MindCloud` : 'MindCloud';
  }
);
